import { AGENT_PERFORMANCE_FILTERS } from './types';

export enum ViewType {
  TEAM_LEAD = 'TEAM_LEAD',
  SENIOR_TEAM_LEAD = 'SENIOR_TEAM_LEAD'
}

export enum FILTER_TYPE {
  AGENT = 'AGENT',
  TEAM_LEAD = 'TEAM_LEAD'
}

export const AGENT_PERFORMANCE = 'agentPerformance';

export const TIME_CELL_WIDTH = 60;

export const DEFAULT_PAGE_SIZE = '50';
export const DEFAULT_PAGE_NO = '1';
export const BREAK_LIMIT = 90;

export const EXPECTED_ACTIVE_MINUTES = 450;

export enum FILTER_LABELS {
  NOT_LOGGED_IN = 'Not Logged In',
  LATE_LOGGED_IN = 'Late Logged In',
  LESS_ACTIVE = 'Less Active',
  AWAY = 'Away',
  EXCEEDED_BREAK = 'Exceeded break',
  CALLS_NOT_DONE = 'Calls not done',
  LESS_AMEYO_TIME = 'Less ameyo time'
}
export const DEFAULT_OPTION = 'All';
export const DEFAULT_OPTIONS = [
  {
    id: 'All',
    value: 'All',
    label: 'All'
  },
  {
    id: 'LoginTime',
    value: 'LoginTime',
    label: 'Login Time'
  },
  {
    id: 'LogoutTime',
    value: 'LogoutTime',
    label: 'Logout Time'
  },
  {
    id: 'FirstCall',
    value: 'FirstCall',
    label: 'First Call'
  },
  {
    id: 'BreakHrs',
    value: 'BreakHrs',
    label: 'Break Hrs'
  },
  {
    id: 'ActiveHrs',
    value: 'ActiveHrs',
    label: 'Active Hrs'
  }
];

export const ALL_FILTERS = [
  {
    value: AGENT_PERFORMANCE_FILTERS.NOT_LOGGED_IN,
    label: FILTER_LABELS.NOT_LOGGED_IN,
    toolTipContent: 'Agents who have not logged in today'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.LATE_LOGGED_IN,
    label: FILTER_LABELS.LATE_LOGGED_IN,
    toolTipContent: 'Agents who logged in after 9:30 AM'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.LESS_ACTIVE,
    label: FILTER_LABELS.LESS_ACTIVE,
    toolTipContent: 'Agents active for less than 25% of total hrs elapsed today'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.AWAY,
    label: FILTER_LABELS.AWAY,
    toolTipContent: 'Agents currently away from Longhorn'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.EXCEEDED,
    label: FILTER_LABELS.EXCEEDED_BREAK,
    toolTipContent: 'Agents whose break exceeded 1.5 hours'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.CALLS_NOT_DONE,
    label: FILTER_LABELS.CALLS_NOT_DONE,
    toolTipContent: 'Agents who have not made any calls yet'
  },
  {
    value: AGENT_PERFORMANCE_FILTERS.LESS_AMEYO_TIME,
    label: FILTER_LABELS.LESS_AMEYO_TIME,
    toolTipContent: 'Agents with less than the required active time'
  }
];

export enum BREAK_LABELS {
  MORNING_BREAK = 'MORNING_BREAK',
  LUNCH_BREAK = 'LUNCH_BREAK',
  MEETING = 'MEETING',
  EVENING_BREAK = 'EVENING_BREAK',
  TRAINING = 'TRAINING',
  OTHERS = 'OTHERS'
}

export const BREAK_LABELS_MAP = {
  [BREAK_LABELS.MORNING_BREAK]: 'morning break',
  [BREAK_LABELS.LUNCH_BREAK]: 'lunch break',
  [BREAK_LABELS.MEETING]: 'meeting',
  [BREAK_LABELS.EVENING_BREAK]: 'evening break',
  [BREAK_LABELS.TRAINING]: 'training',
  [BREAK_LABELS.OTHERS]: 'other break'
};
